import * as React from 'react';
import Link from 'next/link';
import { AppBar, Toolbar } from '@mui/material';
import MobileSubHeader from './sub-header';
import { useServerAuth } from '@/auth';

interface MobileProps {
  showLinks: boolean;
}

const Mobile: React.FC<MobileProps> = ({ showLinks }) => {
  const { hydrated, user } = useServerAuth();
  const isLogged = !!user && hydrated;
  return (
    <div className="lg:hidden">
      <AppBar position="fixed" className="h-[60px] sm:h-[70px]">
        <Toolbar className="flex justify-between items-center sm:h-full">
          <Link href={isLogged ? '/my-home' : '/'}>
            <img
              loading="lazy"
              src="/assets/images/logotipo-white.svg"
              alt="Vibly"
              className="h-[35px] w-auto"
            />
          </Link>
          <MobileSubHeader showLinks={showLinks} />
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default Mobile;
